package team.platforma.aicombo.theme.colors

import androidx.compose.ui.graphics.Color

object RawColors {
    object Light {
        val surface_base = Color(0xFFFFFFFF)

        val bg_disabled = Color(0xFFE7E7EA)

        val bg_base_default = Color(0xFFFFFFFF)
        val bg_base_hover = Color(0xFFEAEAEE)
        val bg_base_press = Color(0xFFE7E7EA)
        val bg_base_focus = Color(0xFFFFFFFF)
        val bg_base_loading = Color(0xFFE7E7EA)

        val bg_default_default = Color(0xFFF3F3F7)
        val bg_default_hover = Color(0xFFE7E7EA)
        val bg_default_press = Color(0xFFDBDBDE)
        val bg_default_focus = Color(0xFFF3F3F7)
        val bg_default_loading = Color(0xFFDBDBDE)

        val bg_primary_default = Color(0xFF7C1DD6)
        val bg_primary_hover = Color(0xFF6015B8)
        val bg_primary_press = Color(0xFF470E9A)
        val bg_primary_focus = Color(0xFF7C1DD6)
        val bg_primary_loading = Color(0xFF470E9A)

        val bg_primary_invert_default = Color(0xFFF0D1FC)
        val bg_primary_invert_hover = Color(0xFFDEA4FA)
        val bg_primary_invert_press = Color(0xFFC274F2)
        val bg_primary_invert_focus = Color(0xFFF0D1FC)
        val bg_primary_invert_loading = Color(0xFFC274F2)

        val bg_success_default = Color(0xFF90CE11)
        val bg_success_hover = Color(0xFF75B10D)
        val bg_success_press = Color(0xFF5C9406)
        val bg_success_focus = Color(0xFF90CE11)
        val bg_success_loading = Color(0xFF5C9406)

        val bg_warning_default = Color(0xFFFC9F02)
        val bg_warning_hover = Color(0xFFD88000)
        val bg_warning_press = Color(0xFFB56400)
        val bg_warning_focus = Color(0xFFFC9F02)
        val bg_warning_loading = Color(0xFFB56400)

        val bg_error_default = Color(0xFFFC2D25)
        val bg_error_hover = Color(0xFFD81B24)
        val bg_error_press = Color(0xFFB51228)
        val bg_error_focus = Color(0xFFFC2D25)
        val bg_error_loading = Color(0xFFB51228)

        val bg_inform_default = Color(0xFF009FBF)
        val bg_inform_hover = Color(0xFF00789F)
        val bg_inform_press = Color(0xFF015681)
        val bg_inform_focus = Color(0xFF009FBF)
        val bg_inform_loading = Color(0xFF015681)

        val text_light = Color(0xFFFFFFFF)
        val text_base = Color(0xFFFFFFFF)
        val text_default = Color(0xFF33333A)
        val text_primary = Color(0xFF7C1DD6)
        val text_placeholder = Color(0xFF676772)
        val text_caption = Color(0xFF676772)
        val text_link = Color(0xFF009FBF)
        val text_visited = Color(0xFF3DEAEA)
        val text_success = Color(0xFF75B10D)
        val text_info = Color(0xFF04CBDD)
        val text_warning = Color(0xFFFC9F02)
        val text_error = Color(0xFFFC2D25)
        val text_disabled = Color(0xFFCECED2)

        val border_default = Color(0xFFE7E7EA)
        val border_primary = Color(0xFF6015B8)
        val border_focus = Color(0xFFC274F2)
        val border_info = Color(0xFF04CBDD)
        val border_success = Color(0xFF75B10D)
        val border_warning = Color(0xFFFC9F02)
        val border_error = Color(0xFFFC2D25)
        val border_disabled = Color(0xFFDBDBDE)
        val border_dark = Color(0xFF33333A)
    }

    object Dark {
        val surface_base = Color(0xFF24242A)

        val bg_disabled = Color(0xFF3D3D49)

        val bg_base_default = Color(0xFF24242A)
        val bg_base_hover = Color(0xFF3D3D49)
        val bg_base_press = Color(0xFF676772)
        val bg_base_focus = Color(0xFF24242A)
        val bg_base_loading = Color(0xFF3D3D49)

        val bg_default_default = Color(0xFF0E0E10)
        val bg_default_hover = Color(0xFF3D3D49)
        val bg_default_press = Color(0xFF24242A)
        val bg_default_focus = Color(0xFF24242A)
        val bg_default_loading = Color(0xFF3D3D49)

        val bg_primary_default = Color(0xFF7C1DD6)
        val bg_primary_hover = Color(0xFFA552E6)
        val bg_primary_press = Color(0xFFC274F2)
        val bg_primary_focus = Color(0xFF7C1DD6)
        val bg_primary_loading = Color(0xFFC274F2)

        val bg_primary_invert_default = Color(0xFF230566)
        val bg_primary_invert_hover = Color(0xFF32097C)
        val bg_primary_invert_press = Color(0xFF470E9A)
        val bg_primary_invert_focus = Color(0xFF230566)
        val bg_primary_invert_loading = Color(0xFF470E9A)

        val bg_success_default = Color(0xFF90CE11)
        val bg_success_hover = Color(0xFFB3E145)
        val bg_success_press = Color(0xFFCDF06B)
        val bg_success_focus = Color(0xFF90CE11)
        val bg_success_loading = Color(0xFFCDF06B)

        val bg_warning_default = Color(0xFFFC9F02)
        val bg_warning_hover = Color(0xFFFDBD40)
        val bg_warning_press = Color(0xFFFED165)
        val bg_warning_focus = Color(0xFFFC9F02)
        val bg_warning_loading = Color(0xFFFED165)

        val bg_error_default = Color(0xFFFC2D25)
        val bg_error_hover = Color(0xFFFd6e5a)
        val bg_error_press = Color(0xFFFE967C)
        val bg_error_focus = Color(0xFFFC2D25)
        val bg_error_loading = Color(0xFFFE967C)

        val bg_inform_default = Color(0xFF3DEAEA)
        val bg_inform_hover = Color(0xFF62F4E8)
        val bg_inform_press = Color(0xFF96FCEB)
        val bg_inform_focus = Color(0xFF3DEAEA)
        val bg_inform_loading = Color(0xFF96FCEB)

        val text_light = Color(0xFFFFFFFF)
        val text_base = Color(0xFF33333A)
        val text_default = Color(0xFFFFFFFF)
        val text_primary = Color(0xFFC274F2)
        val text_placeholder = Color(0xFFCECED2)
        val text_caption = Color(0xFFCECED2)
        val text_link = Color(0xFF04CBDD)
        val text_visited = Color(0xFF009FBF)
        val text_success = Color(0xFFB3E145)
        val text_info = Color(0xFF04CBDD)
        val text_warning = Color(0xFFFDBD40)
        val text_error = Color(0xFFFd6e5a)
        val text_disabled = Color(0xFF676772)

        val border_default = Color(0xFF3D3D49)
        val border_primary = Color(0xFFC274F2)
        val border_focus = Color(0xFF6015B8)
        val border_info = Color(0xFF04CBDD)
        val border_success = Color(0xFFB3E145)
        val border_warning = Color(0xFFFDBD40)
        val border_error = Color(0xFFFd6e5a)
        val border_disabled = Color(0xFF3D3D49)
        val border_dark = Color(0xFF676772)
    }
}